(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const colourMap = [
    ['graphite heather', '#55565a'], ['dark heather', '#4b4b4d'],
    ['heather navy', '#31445d'], ['heather royal', '#416aa3'],
    ['sport grey', '#a9aaad'], ['ash', '#c7c7c5'], ['charcoal', '#45484c'],
    ['black', '#111111'], ['white', '#f6f4ee'], ['navy', '#18263f'],
    ['royal', '#2458a6'], ['light blue', '#9fc7df'], ['jade dome', '#568f86'],
    ['military green', '#596447'], ['forest green', '#244d35'],
    ['irish green', '#2c9b58'], ['maroon', '#6e2939'], ['red', '#c9353e'],
    ['orange', '#dc6d2d'], ['yellow', '#e4c84b'], ['purple', '#68477f'],
    ['pink', '#d99aab'], ['sand', '#c8b596'], ['natural', '#ded2bb'],
    ['brown', '#6c4939'], ['grey', '#888b8e'], ['gray', '#888b8e'],
    ['blue', '#537eae'], ['green', '#4f7656']
  ];

  const clean = value => value.replace(/\s*-\s*(sold out|unavailable).*$/i, '').trim();
  const currentValue = select => clean(select.options[select.selectedIndex]?.text || '');
  const swatch = value => {
    const lower = value.toLowerCase().trim();
    return (colourMap.find(([name]) => lower.includes(name)) || [null, '#777b82'])[1];
  };

  function enhanceOption(wrapper) {
    if (!desktop.matches || wrapper.classList.contains('gpt-desktop-enhanced')) return;
    const select = wrapper.querySelector('select');
    if (!select) return;

    const sourceLabel = wrapper.querySelector('label');
    const label = (sourceLabel?.textContent || select.name || 'Option').replace(/:.*$/, '').trim();
    const isColour = /colou?r/i.test(label);
    const isSize = /size/i.test(label);

    const block = document.createElement('div');
    block.className = `gpt-desktop-variant${isColour ? ' gpt-desktop-colour' : ''}${isSize ? ' gpt-desktop-size' : ''}`;

    const heading = document.createElement('div');
    heading.className = 'gpt-desktop-variant-heading';
    const strong = document.createElement('strong');
    strong.textContent = `${label}:`;
    const selected = document.createElement('span');
    selected.textContent = currentValue(select);
    heading.append(strong, selected);

    if (isSize) {
      const chart = document.querySelector('[class*="ai-size-chart-trigger-wrapper-"]');
      if (chart) {
        const trigger = chart.querySelector('[class*="ai-size-chart-trigger-"]');
        if (trigger && /view\s*size\s*chart/i.test(trigger.textContent || '')) trigger.textContent = 'Size Chart';
        heading.append(chart);
      }
    }

    const buttons = document.createElement('div');
    buttons.className = 'gpt-desktop-variant-buttons';
    buttons.setAttribute('role', 'group');
    buttons.setAttribute('aria-label', label);

    const sync = () => {
      selected.textContent = currentValue(select);
      buttons.querySelectorAll('button').forEach(button => {
        const active = button.dataset.value === select.value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    [...select.options].forEach(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `gpt-desktop-variant-button${isColour ? ' gpt-desktop-color-button' : ''}`;
      button.dataset.value = option.value;
      button.textContent = clean(option.text);
      button.title = button.textContent;
      button.setAttribute('aria-label', `${label} ${button.textContent}`);
      button.disabled = option.disabled;
      if (isColour) button.style.setProperty('--gpt-desktop-swatch', swatch(button.textContent));
      button.addEventListener('click', () => {
        if (button.disabled) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        requestAnimationFrame(sync);
      });
      buttons.append(button);
    });

    select.addEventListener('change', sync);
    block.append(heading, buttons);
    wrapper.insertBefore(block, wrapper.firstChild);
    wrapper.classList.add('gpt-desktop-enhanced');
    sync();
  }

  function moveReview(details) {
    if (details.querySelector('.gpt-desktop-review-badge')) return;
    const badge = document.querySelector('.jdgm-prev-badge, .jdgm-preview-badge');
    if (!badge) return;
    badge.classList.add('gpt-desktop-review-badge');
    const firstGroup = details.querySelector('.group-block') || details;
    firstGroup.prepend(badge);
  }

  function enhancePrice(details) {
    const priceBlock = details.querySelector('product-price') || details.querySelector('.price')?.parentElement;
    if (!priceBlock) return;
    const compare = priceBlock.querySelector('.compare-at-price, s, del');
    if (compare?.textContent.trim() && !priceBlock.querySelector('.gpt-desktop-sale-badge')) {
      const badge = document.createElement('span');
      badge.className = 'gpt-desktop-sale-badge';
      badge.textContent = 'Sale';
      (priceBlock.querySelector('.price') || priceBlock).append(badge);
    }
    if (!priceBlock.parentElement?.querySelector(':scope > .gpt-desktop-shipping-note')) {
      const note = document.createElement('div');
      note.className = 'gpt-desktop-shipping-note';
      note.textContent = 'Shipping calculated at checkout.';
      priceBlock.insertAdjacentElement('afterend', note);
    }
  }

  function arrangePurchase(details) {
    const addButton = details.querySelector('.add-to-cart-button');
    const afterpay = details.querySelector('afterpay-placement, square-placement, [data-afterpay-placement]');
    if (!addButton || !afterpay) return;
    const form = addButton.closest('.product-form-buttons') || addButton.parentElement;
    const afterpayBlock = afterpay.closest('.shopify-block, [id^="shopify-block-"], .app-block') || afterpay.parentElement || afterpay;
    if (!form || !afterpayBlock || form.contains(afterpayBlock)) return;
    afterpayBlock.classList.add('gpt-desktop-afterpay');
    if (form.nextElementSibling !== afterpayBlock) form.insertAdjacentElement('afterend', afterpayBlock);
  }

  function apply() {
    if (!desktop.matches) return;
    const details = document.querySelector('.product-details');
    if (!details) return;
    details.querySelectorAll('.variant-option--dropdowns, .variant-option').forEach(enhanceOption);
    moveReview(details);
    enhancePrice(details);
    arrangePurchase(details);
  }

  function start() {
    apply();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        apply();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    desktop.addEventListener?.('change', () => location.reload());
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();
